/**
 * Captures API
 * Mimir capture (unconfirmed object) review operations
 */

import { apiFetch } from './config';

export interface RefusalFlag {
  is_refusal: boolean;
  refusal_indicators?: string[];
  has_embedded_data?: boolean;
}

export interface Capture {
  document_id: string;
  name: string;
  object_type: string;
  entity_type: string | null;
  document_type: string | null;
  domain: string | null;
  tags: string[] | null;
  status: string;
  review_status: 'pending' | 'confirmed' | 'discarded';
  source_url: string | null;
  capture_method: string | null;
  registered_by: string | null;
  entity_properties: Record<string, unknown> | null;
  created_at: string;
  updated_at: string;
  refusal_flag: RefusalFlag;
}

export interface CapturesListResponse {
  records: Capture[];
  count: number;
  status_counts: Record<string, number>;
}

export interface CaptureActionPayload {
  object_id: string;
  action: 'confirm' | 'discard' | 'restore' | 'archive';
  edits?: {
    name?: string;
    tags?: string[];
    domain?: string;
  };
}

export interface CaptureActionResponse {
  object_id: string;
  action: string;
  new_status: string;
  name: string;
  reviewer: string;
}

export const capturesApi = {
  list: async (status?: string) => {
    const qs = new URLSearchParams();
    if (status) qs.set('status', status);
    const query = qs.toString();
    return apiFetch<CapturesListResponse>(
      `/api/captures${query ? '?' + query : ''}`
    );
  },

  action: async (payload: CaptureActionPayload) => {
    return apiFetch<CaptureActionResponse>('/api/captures/action', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },
};
